/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Boeck <d.boeck@techdivision.com>
 */

import React from 'react';
import PropTypes from 'prop-types';
import ErrorTemplate from './ErrorTemplate';

/**
 * We need this functional error boundary component to have a visualisation of the error
 *
 * @param fallback
 * @param error
 * @param children
 * @returns {*}
 * @constructor
 */
export function ErrorBoundaryRender({ fallback, error, children }) {
  if (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return fallback;
  }
  return children;
}

ErrorBoundaryRender.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.object]),
};

ErrorBoundaryRender.defaultProps = {
  fallback: <ErrorTemplate />,
};
